import React, { useEffect, useState } from "react";
import { usePackageContext } from "../..";
import styles from "./styles";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Stack,
  styled,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getApiData } from "../../../../utils/APIHelper";
import { toast } from "react-toastify";
import {
  formattedAmount,
  getImageSrc,
  transformDateFormat,
} from "../../../../utils/CommonFunction";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import InclusionVariantList from "./InclusionVariantList";
import GroupInclusionList from "./GroupInclusionList";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function Review() {
  const { id } = useParams();
  const { packageDetails, setPackageDetails } = usePackageContext();
  const navigate = useNavigate();

  const [buttonLoader, setButtonLoader] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (packageDetails && packageDetails?.id) {
      getDetailsApiCall(packageDetails?.id);
    }
  }, [packageDetails?.id]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/package/${id}`,
        "GET",
        {},
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        setPackageDetails(response);
        setLoader(false);
      } else {
        toast.error("Oops! Something went wrong");
      }
    } catch (error) {
      toast.error(error.toString());
    }
  }

  const handlePrevious = () => {
    navigate(`/new-create-package/${packageDetails?.id}/images`);
  };

  const handleModalClose = () => {
    navigate("/packages");
  };

  async function handleSubmit() {
    setButtonLoader(true);
    const data = {
      status: "SUBMITTED",
    };
    try {
      const response = await getApiData(
        `api/v2/package/${packageDetails?.id}`,
        "PATCH",
        data,
        { "Content-Type": "application/json" },
        true
      );
      setButtonLoader(false);
      if (response) {
        toast.success(response.message || "Package submitted successfully");
        navigate("/packages");
      } else {
        toast.error(response.message || "Something went wrong. Try later");
      }
    } catch (error) {
      console.log("err===>", error);
    }
  }

  return loader ? (
    <center>
      <CircularProgress />
    </center>
  ) : (
    <div style={{ ...styles.container, ...styles.columnFlex, gap: "20px" }}>
      <h3 style={styles.heading}>Review</h3>
      <div style={{ display: "flex" }}>
        <div style={{ ...styles.rowFlex, gap: "15px", flex: "2" }}>
          <Box
            component="img"
            src={getImageSrc(packageDetails?.image?.path)}
            alt="Package Image"
            sx={{
              width: 80,
              height: 80,
              borderRadius: "16px",
              marginRight: 1,
            }}
          />
          <div style={styles.columnFlex}>
            <div style={{ ...styles.rowFlex, gap: "15px" }}>
              <p style={{ ...styles.idLabel, ...styles.rowFlex, gap: "5px" }}>
                <NewDesignIcon /> {packageDetails?.projectType}
              </p>
            </div>
            <h2 style={styles.projectHeading}>{packageDetails?.name}</h2>
          </div>
        </div>

        <div style={{ ...styles.columnFlex, flex: "1" }}>
          <p style={styles.idLabel}>Cost</p>
          <p style={styles.price}>{formattedAmount(packageDetails?.cost)}</p>
        </div>

        <div style={{ ...styles.columnFlex, flex: "1" }}>
          <p style={styles.idLabel}>Owner</p>
          <p style={styles.price}>
            <Box display="flex" alignItems="center">
              {packageDetails?.owner && (
                <Box
                  component="img"
                  src={getImageSrc(packageDetails?.owner?.profileUrl)}
                  alt="Project Icon"
                  sx={{
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    boxShadow: "0px 4px 2.67px 0px #00000026",
                    marginRight: 1,
                  }}
                />
              )}
              {packageDetails?.owner?.companyName}
            </Box>
          </p>
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ ...styles.columnFlex, flex: "1" }}>
          <p style={styles.sub_heading}>Budget Type</p>
          <p style={styles.text}>
            {getStatusDisplayText(packageDetails?.budgetType)}
          </p>
        </div>

        <div style={{ ...styles.columnFlex, flex: "1" }}>
          <p style={styles.sub_heading}>Timeline</p>
          <p style={styles.text}>{packageDetails?.timeline}</p>
        </div>

        <div style={{ ...styles.columnFlex, flex: "1" }}>
          <p style={styles.sub_heading}>No. of Bedrooms</p>
          <p style={styles.text}>{packageDetails?.sizeMetadata}</p>
        </div>
      </div>

      <div style={styles.columnFlex}>
        <h3 style={styles.sub_heading}>Package Summary</h3>
        <div style={styles.text}>{packageDetails?.description}</div>
      </div>

      <div style={styles.columnFlex}>
        <h3 style={styles.sub_heading}>Tags</h3>
        <div
          style={{
            ...styles.rowFlex,
            ...styles.text,
            gap: "15px",
          }}
        >
          {packageDetails?.tags?.map((tag, index) => (
            <div
              style={{
                backgroundColor: "#17204f",
                color: "#fff",
                padding: ".5vh 1vw",
                margin: ".3vh .1vw",
                width: "fit-content",
                borderRadius: "18px",
                fontSize: "14px",
              }}
              key={index}
            >
              {tag?.name}
            </div>
          ))}
        </div>{" "}
      </div>

      <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
        <div style={{ ...styles.rowFlex, flex: 1, gap: "5px" }}>
          <h3 style={styles.text}>Created At:</h3>
          <div style={styles.sub_heading}>
            {transformDateFormat(packageDetails?.createdAt)}
          </div>
        </div>{" "}
        <div
          style={{
            ...styles.rowFlex,
            flex: 1,
            gap: "5px",
            justifyContent: "flex-end",
          }}
        >
          <h3 style={styles.text}>Updated At:</h3>
          <div style={styles.sub_heading}>
            {transformDateFormat(packageDetails?.updatedAt)}
          </div>
        </div>
      </div>

      <InclusionVariantList packageDetails={packageDetails} />

      <GroupInclusionList packageDetails={packageDetails} />
      <Divider sx={{ width: "100%" }} />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GreyStyledButton onClick={handlePrevious}>
          {buttonLoader ? (
            <CircularProgress size={26} style={{ color: "#fff" }} />
          ) : (
            "Previous Step"
          )}
        </GreyStyledButton>

        <Stack
          alignItems="end"
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
        >
          <GreyStyledButton onClick={handleModalClose}>Close</GreyStyledButton>
          <StyledButton variant="contained" onClick={handleSubmit}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Submit"
            )}
          </StyledButton>{" "}
        </Stack>
      </Stack>
    </div>
  );
}
export default Review;
